import {useCallback, useState} from 'react'
import {useLocation} from 'react-router'
import styles from './IdeationActions.module.scss'
import {ideationApi} from '../../../../../../api/ideationApi'
import {ReactComponent as Plus} from '../../../../../../assets/Icons/Plus.svg'
import {AddOrEditTaskModal} from '../../../../../Tasks/components/AddOrEditTaskModal/AddOrEditTaskModal'
import {ITask} from '../../../../../../types'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {IDEATION} from '../../../../../../Translation/English/ideation'
import {TASK} from '../../../../../../Translation/English/task'

export const IdeationActions: React.FC = () => {
  const wt = useWt()
  const {search} = useLocation()
  const ideationId = search ? search.substring(1) : ''
  const [isShowAddTaskModal, setIsShowAddTaskModal] = useState<boolean>(false)
  const [selectTask, setSelectTask] = useState<ITask | undefined>(undefined)
  const {data: ideation} = ideationApi.useIdeation(ideationId)
  const {data: insights} = ideationApi.useIdeationInsights(ideationId)
  const actions = insights?.actionables

  const closeAddTaskModal = useCallback(() => {
    setSelectTask(undefined)
    setIsShowAddTaskModal(false)
  }, [])

  const createTaskPopUp = async (taskText: string): Promise<void> => {
    setSelectTask({
      name: taskText,
      initiativeId: String(ideation?.initiativeId ?? ''),
      status: 'PENDING',
    } as ITask)
    setIsShowAddTaskModal(true)
  }

  return (
    <div className={styles.ideationActions}>
      <div className="ideation-section-title">
        {wt(IDEATION.actionableInsights)}
      </div>

      <ul className={styles.ideationActionsDiv}>
        {actions?.map((item, index) => (
          <li className={styles.ideationActionsItem} key={index}>
            <div className={styles.ideationActionsList}>{item}</div>
            <button
              type="button"
              className={styles.ideationActionsBtn2}
              aria-label={wt(TASK.createTask)}
              onClick={() => createTaskPopUp(item)}
            >
              <Plus />
            </button>
          </li>
        ))}
      </ul>
      {isShowAddTaskModal ? (
        <AddOrEditTaskModal
          isShowModal={isShowAddTaskModal}
          closeAddTaskModal={closeAddTaskModal}
          selectTask={selectTask}
          onlyAdd={true}
          initID={
            ideation?.initiativeId !== undefined
              ? String(ideation.initiativeId)
              : undefined
          }
        />
      ) : null}
    </div>
  )
}
